import SDIcon from './SDIcon'

const IconCarbonError = (props) => (
  <SDIcon title='Error' {...props}>
    <path
    d='M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z'
    transform='translate(0)'
    />
  </SDIcon>
)

export default IconCarbonError
